import { useAuth } from '@hourly/contexts/AuthContext';
import { useRequest } from '@hourly/hooks/useRequest';
import { RevenueShareStatus } from '../models/revenueShare.model';
import { getRevenueShareExportFilename } from '../requests/revenueShareExport.request';

export const useRevenueShareExport = () => {
  const { sessionState } = useAuth();

  const { request: fetchExportFilename } = useRequest<
    { period: string; status: RevenueShareStatus },
    {
      filename: string;
    }
  >(
    async (params) => {
      return getRevenueShareExportFilename(params, sessionState.partnerId!);
    },
    { requestOnMount: false }
  );

  return { fetchExportFilename };
};
